export type CaptureTiming = {
  bundle_load_ms?: number;
  page_ready_ms?: number;
  capture_ms?: number;
};
export type CaptureTelemetry = {
  timing: CaptureTiming;
  failureStage?: "bundle_load" | "page_ready" | "capture" | "upload_transport";
};

export async function measureCaptureStep<T>(
  telemetry: CaptureTelemetry | undefined,
  stage: NonNullable<CaptureTelemetry["failureStage"]>,
  key: keyof CaptureTiming,
  run: () => Promise<T>,
): Promise<T> {
  if (telemetry) telemetry.failureStage = stage;
  const start = performance.now();
  try {
    return await run();
  } finally {
    if (telemetry)
      telemetry.timing[key] = Math.round(performance.now() - start);
  }
}
